import React, { useEffect, useState } from "react";
import { HeaderTitle } from "../helpfull/HeaderTitle";
import { Plate } from "../helpfull/Plate";
import { AnalyticsButton } from "../helpfull/AnalyticsButton";
import { Task } from "./Task";
import { Analytics } from "./UpdateStorage/UpdateStorage";

import { getProperAge, getAgeInversion, getDay, postDay } from "./utils";
import { getBeautifulHoursMinutes } from "./utils/getBeautifulHoursMinutes";

import { eveningSuggestions, morningSuggestions } from "./suggestionsConfig";

import BEM from "./Routine.module.scss";
import headingIcon from "./assets/headericon.svg";

export const Routine = () => {
  const [age, setAge] = useState(getProperAge());
  const [isAnalyticsVisible, setIsAnalyticsVisible] = useState(false);

  const [isSuggestionsOpened, setIsSuggestionsOpened] = useState(false);

  const [dayState, setDayState] = useState("loading");

  const loadDays = async () => {
    setDayState("loading");

    const day = await getDay();

    setDayState(day);
  };

  const makeTaskCompleted = async (id) => {
    const freshDay = { ...dayState };

    const task = freshDay[age].find((task) => task.id === id);

    task.isCompleted = true;
    task.momentOfCompletion = Date.now();

    setDayState("loading");
    await postDay(freshDay);
    loadDays();
  };

  const handleSwitchAgeClick = () => {
    setAge(getAgeInversion(age));
    loadDays();
  };

  useEffect(() => {
    loadDays();
  }, []);

  return (
    <Plate>
      <header className={BEM.header}>
        <HeaderTitle title="Дрібна рутина" icon={headingIcon} />
        <div className={BEM.headerIcons}>
          <button
            className={BEM.switchAgeBtn}
            onClick={handleSwitchAgeClick}
          ></button>

          <button
            className={BEM.suggestionsToggler}
            onClick={() => setIsSuggestionsOpened(!isSuggestionsOpened)}
          >
            hints?
          </button>

          <AnalyticsButton
            onClick={() => setIsAnalyticsVisible(!isAnalyticsVisible)}
          />
        </div>
      </header>

      <main className={BEM.conent}>
        {isAnalyticsVisible && <Analytics />}

        {isSuggestionsOpened && (
          <div className={BEM.suggestionsContainer}>
            {age === "morning" && morningSuggestions}
            {age === "evening" && eveningSuggestions}
          </div>
        )}

        <p className={BEM.ageName}>
          {age === "morning" && "Ранок:"}
          {age === "evening" && "Вечір:"}
        </p>
        <ul className={BEM.tasks}>
          {dayState === "loading" && <p className={BEM.message}>Loading...</p>}
          {dayState !== "loading" && dayState[age].length === 0 && (
            <p className={BEM.message}>Loading...</p>
          )}
          {dayState !== "loading" &&
            dayState[age].length !== 0 &&
            dayState[age]
              .filter(
                ({ isCompleted, type }) => !isCompleted || type === "fixed"
              )
              .map((task) => (
                <Task
                  key={task.id}
                  className={BEM.task}
                  title={task.title}
                  highlighting={task.highlighting}
                  type={task.type}
                  link={task.link}
                  isCompleted={task.isCompleted}
                  onCompleteClick={() => makeTaskCompleted(task.id)}
                >
                  {task.type === "fixed" &&
                    task.momentOfCompletion &&
                    getBeautifulHoursMinutes(new Date(task.momentOfCompletion))}
                </Task>
              ))}
        </ul>
      </main>
    </Plate>
  );
};
